export const LOGS_RECORD = 'LOGS_RECORD'
export const BULK_DATA_CSV = 'BULK_DATA_CSV'
export const TRACK_PROGRESS_BAR = 'TRACK_PROGRESS_BAR'
